import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModuleFormValues, moduleSchema } from "@modules/agreements/validations";
import { useEditModuleMutation } from "@modules/agreements/services/mutations";
import { EditModuleModalProps } from "./types";

export function useEditModuleModal({ modalRef, onRefetch }: EditModuleModalProps) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<ModuleFormValues>({
    resolver: zodResolver(moduleSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useEditModuleMutation({
    onSuccess: () => {
      onRefetch();

      open?.({
        type: "success",
        message: translate("agreement_modules_admin.success.edit"),
      });

      modalRef.current?.close();
    },
  });

  const handleSubmit = async () => {
    try {
      const moduleId = modalRef.current?.getId();
      const values = methods.getValues();

      await mutateAsync({ id: moduleId as string, data: values });
    } catch (error) {
      console.error("Error creating module:", error);
    }
  };

  return {
    methods,
    isPending,
    handleSubmit,
  };
}
